export interface IVoyageNavData {
  locationName: string
  isStarbase: boolean
}

export const navLocations: IVoyageNavData[] = [
  {
    locationName: 'Starbase-7',
    isStarbase: true,
  },
  {
    locationName: 'Starbase-12',
    isStarbase: true,
  },
  {
    locationName: 'Enemy territory',
    isStarbase: false,
  },
  {
    locationName: 'Mission: hammerhead',
    isStarbase: false,
  },
  {
    locationName: 'Mission: aliens',
    isStarbase: false,
  },
]
